export default __webpack_public_path__ + "static/media/0x8f3cf7ad23cd3cadbd9735aff958023239c6a063.849478a7.png";